import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Privacy Policy</h1>
      <p style={styles.lastUpdated}>Last Updated: December 2025</p>

      <section style={styles.section}>
        <h2 style={styles.h2}>1. Introduction</h2>
        <p>
          This Privacy Policy explains how we collect, use, and disclose your personal information 
          when you visit our website. By using our services, you agree to the terms outlined in 
          this policy. We are committed to protecting your privacy in accordance with United 
          States federal and state privacy laws.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>2. Information We Collect</h2>
        <p>We may collect the following categories of information:</p>
        <ul style={styles.list}>
          <li><strong>Identifiers:</strong> Such as IP address, cookie identifiers, and browser type.</li>
          <li><strong>Activity:</strong> Information about your interaction with our website.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>3. California Privacy Rights (CCPA/CPRA)</h2>
        <p>
          If you are a California resident, you have the right to:
        </p>
        <ul style={styles.list}>
          <li>Know what personal information is being collected about you.</li>
          <li>Request the deletion of your personal information.</li>
          <li>Opt-out of the "sale" or "sharing" of your personal information.</li>
        </ul>
        <p>To exercise these rights, please contact us at the email provided below.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>4. Cookies and Tracking</h2>
        <p>
          We use cookies to analyze web traffic and optimize your experience. You can choose 
          to accept or decline cookies through the consent banner provided upon entry.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>5. Children's Privacy (COPPA)</h2>
        <p>
          Our website is not intended for children under the age of 13. We do not knowingly 
          collect personal information from children.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>6. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:
          <br />
          <strong>Email:</strong> privacy@yourdomain.com
        </p>
      </section>

      <footer style={styles.footer}>
        <button onClick={() => window.history.back()} style={styles.backButton}>
          Go Back
        </button>
      </footer>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "800px",
    margin: "40px auto",
    padding: "40px",
    backgroundColor: "#fff",
    color: "#333",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    lineHeight: "1.6",
    textAlign: "left",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
  },
  h1: { fontSize: "32px", color: "#111", borderBottom: "2px solid #eee", paddingBottom: "10px" },
  h2: { fontSize: "20px", color: "#222", marginTop: "30px", marginBottom: "10px" },
  lastUpdated: { fontSize: "14px", color: "#777", marginBottom: "20px" },
  section: { marginBottom: "25px" },
  list: { paddingLeft: "20px", marginBottom: "15px" },
  footer: { marginTop: "50px", borderTop: "1px solid #eee", paddingTop: "20px" },
  backButton: {
    padding: "10px 20px",
    backgroundColor: "#1e73ff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold"
  }
};

export default PrivacyPolicy;